"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_hanger_1 = require("react-hanger");
const reactstrap_1 = require("reactstrap");
const CreateResourceModalForm_1 = require("./CreateResourceModalForm");
function CreateResourcesButton(props) {
    const { state: { isFormOpen }, setState, } = react_hanger_1.useSetState({
        isFormOpen: false,
    });
    const { label, options, onSelect, modalProps, disabled } = props;
    const modalForm = modalProps && (react_1.default.createElement(CreateResourceModalForm_1.CreateResourceModalForm, Object.assign({ isOpen: isFormOpen, disabled: disabled }, modalProps, { onToggle: isOpen => {
            setState({ isFormOpen: isOpen });
            if (modalProps.onToggle) {
                modalProps.onToggle(isOpen);
            }
        }, formProps: Object.assign(Object.assign({}, modalProps.formProps), { mutationProps: Object.assign(Object.assign({}, modalProps.formProps.mutationProps), { onCompleted: d => {
                    setState({
                        isFormOpen: false,
                    });
                    if (modalProps.formProps.mutationProps) {
                        modalProps.formProps.mutationProps.onCompleted(d);
                    }
                } }) }) })));
    if (!options) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Button, { "data-osmosys-comp": "CreateResourcesButton.Button", color: "success", size: "sm", onClick: () => {
                    setState({
                        isFormOpen: true,
                    });
                    if (onSelect) {
                        onSelect();
                    }
                } },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlusSquare, className: "mr-2" }),
                label),
            modalForm));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.UncontrolledButtonDropdown, { size: "sm" },
            react_1.default.createElement(reactstrap_1.DropdownToggle, { "data-osmosys-comp": "CreateResourcesButton.DropdownToggle", color: "success", size: "sm", caret: true },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPlusSquare, className: "mr-2" }),
                label),
            react_1.default.createElement(reactstrap_1.DropdownMenu, { className: "text-left", "data-osmosys-comp": "CreateResourcesButton.DropdownMenu" }, options &&
                options.map(opt => {
                    return (react_1.default.createElement(reactstrap_1.DropdownItem, { key: opt.value, onClick: (e) => {
                            e.target.blur();
                            onSelect(opt);
                        } }, opt.label));
                }))),
        ' ',
        modalForm));
}
exports.CreateResourcesButton = CreateResourcesButton;
//# sourceMappingURL=CreateResourcesButton.js.map